<template>
  <v-card class="mx-auto thiscard" shaped outlined raised :max-width="maxwidth">
    <v-card-title class="px-3 pb-0">
      <template v-if="ques.isRequired">
        <div class="quest_topic">
        <v-icon color="primary">mdi-exclamation-thick</v-icon> 必填
        </div>
      </template>
      <template v-if="ques.isAssign">
        <div class="quest_topic">
        <v-icon color="primary">mdi-exclamation-thick</v-icon> 指定檢核
        </div>
      </template>
    </v-card-title>
    <slot name="content"></slot>
  </v-card>
</template>

<script>
export default {
  props: {
    maxwidth: { type: Number, default: null },
    ques: { type: Object, default: null }
  }
}
</script>

<style lang="scss" scoped>
.thiscard {
  border-radius: 10px !important;
}
</style>
